import Vue from 'vue';
const resource = '/alerts';

export default {
  // CUSTOM ENDPOINT
  getSideBarAlerts() {
    return Vue.prototype.$axiosMainClient.get(`${resource}?group=sidebar`);
  },
};
